import { DashboardRoutePath } from 'modules/dashboard/navigation';
import { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { useFormContext } from 'react-hook-form';
import { FlexContainer } from 'shared/Typhography/flex-box';
import { strings } from 'strings';

import { DeleteIcon } from '../../../../../../assets/Modal';
import ColoringGridImage from '../../../../../../shared/Components/ColoringGridImage/ColoringGridImage';
import UploadImage from '../../../../../../shared/Components/UploadImage/UploadImage';
import { AbsoluteImage, DropZoneContainer } from '../../../../../../shared/Typhography';

interface UploadColoringGridImageProps {
  disableDeleteOption?: boolean;
  onFileChange: (image: any | null) => void;
}

const UploadColoringGridImage = ({
  onFileChange,
  disableDeleteOption,
}: UploadColoringGridImageProps) => {
  const { getValues, formState } = useFormContext();
  const imageSrc = useMemo(() => getValues().image, [formState]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/png',
    onDrop: (files) => onFileChange(files[0]),
  });

  const imageResolution = useMemo(() => getValues().imageResolution, [formState]);

  if (imageSrc) {
    return (
      <div style={{ position: 'relative' }}>
        {!disableDeleteOption && (
          <AbsoluteImage
            top={0}
            right={0}
            left={0}
            bottom={0}
            cursor="pointer"
            src={DeleteIcon}
            alt="remove image"
            onClick={() => onFileChange(null)}
          />
        )}
        <a
          href={`${window.location.origin}/${
            DashboardRoutePath.CONTENT_PREVIEW_SCREEN
          }?type=coloringGrid&url=${encodeURI(imageSrc)}`}
          target="_blank"
          rel="noreferrer"
        >
          <ColoringGridImage
            cursor="pointer"
            style={{
              marginTop: '40px',
              objectFit: 'contain',
              objectPosition: 'center',
              imageRendering: 'pixelated',
            }}
            borderRadiusType="rounded"
            src={imageSrc}
            width="100%"
            height="300px"
          />
        </a>
        <FlexContainer justifyContent="center" margin={{ marginTop: '10px' }}>
          {imageResolution}
        </FlexContainer>
      </div>
    );
  }

  return (
    <>
      <DropZoneContainer {...getRootProps()}>
        <input {...getInputProps()} />
        <UploadImage buttonText={strings.uploadImage} />
      </DropZoneContainer>
    </>
  );
};

export default UploadColoringGridImage;
